module.exports = __webpack_public_path__ + "media/attack.4ba778c9.mp3";